// ----------------------------------------------------------------------------
// Shared bucket cross-tab sync helper.
// Replaces the old 1s IndexedDB poll that caused periodic jank in Firefox with
// a BroadcastChannel-based push sync, plus a slow fallback poll for older browsers.
// ----------------------------------------------------------------------------

function setupBucketSync({ bucket, dbGetAll, channelName = 'ggv-bucket-sync' }) {
   if (!bucket || typeof dbGetAll !== 'function') return;

   let syncChannel = null;

   function broadcastBucketChange() {
      if (syncChannel) {
         try { syncChannel.postMessage({ bucketId: bucket.bucketId }); } catch (_) {}
      }
   }

   function onBucketChangedExternally() {
      try { bucket.load(); } catch (_) {}
   }

   if (typeof BroadcastChannel !== 'undefined') {
      try {
         syncChannel = new BroadcastChannel(channelName);
         syncChannel.onmessage = (e) => {
            if (e.data && e.data.bucketId === bucket.bucketId) {
               onBucketChangedExternally();
            }
         };
      } catch (_) {
         syncChannel = null;
      }
   }

   let lastBucketState = '';
   async function pollBucketChanges() {
      if (document.hidden) return;
      try {
         const dbItems = await dbGetAll(bucket.bucketId);
         const newState = dbItems
            .slice()
            .sort((a, b) => String(a.id).localeCompare(String(b.id)))
            .map(i => i.id + ':' + (i.addedAt || 0))
            .join('|');
         if (newState !== lastBucketState) {
            lastBucketState = newState;
            await bucket.load();
         }
      } catch (err) {
      }
   }

   if (syncChannel) {
      document.addEventListener('visibilitychange', () => {
         if (!document.hidden) onBucketChangedExternally();
      });
      window.addEventListener('focus', onBucketChangedExternally);
   } else {
      setInterval(pollBucketChanges, 5000);
      document.addEventListener('visibilitychange', () => {
         if (!document.hidden) pollBucketChanges();
      });
      window.addEventListener('focus', pollBucketChanges);
   }

   const origAdd = bucket.add.bind(bucket);
   bucket.add = async function(...args) {
      const result = await origAdd(...args);
      broadcastBucketChange();
      return result;
   };
   const origRemove = bucket.remove.bind(bucket);
   bucket.remove = async function(...args) {
      const result = await origRemove(...args);
      broadcastBucketChange();
      return result;
   };
   const origClear = bucket.clear.bind(bucket);
   bucket.clear = async function(...args) {
      const result = await origClear(...args);
      broadcastBucketChange();
      return result;
   };
}

module.exports = { setupBucketSync };
